import script from "./PackageSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageSetting.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__